<template>
  <div class="bg-light py-5">
    <div v-if="showTopbar" class="container mb-2 text-end">
      <template v-if="isAuthenticated">
        <span class="me-2" v-if="isAdmin"><button :class="{active: currentRouteName === 'Admin'}" class="btn btn-sm btn-secondary" @click="admin">Admin</button></span>
        <button class="btn btn-sm btn-danger me-2" @click="logout">Abmelden</button>
        <button @click="openContactForm" type="button" class="btn btn-secondary"><i class="fa-solid fa-envelope"></i></button>
      </template>
    </div>
    <div class="container shadow border rounded-5 p-4 bg-white">
      <div class="text-center mb-4">

        <router-link v-if="props.showHomeLink || isAdmin" :to="{name: 'Home'}"><img class="img-fluid" src="/logo-proeinsatz.png" alt="PROEinsatz" width="300"></router-link>
        <img v-else class="img-fluid" src="/logo-proeinsatz.png" alt="PROEinsatz" width="300">
        <div v-for="status in statusText" class="alert alert-danger" role="alert" :key="status.code">{{ status.message }}</div>
      </div>
      <slot></slot>
    </div>
    <ContactForm />
  </div>
</template>

<script setup>

import {computed, defineProps, onMounted} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Modal from "bootstrap/js/dist/modal";
import ContactForm from "@/components/ContactForm.vue";

const props = defineProps(
    {
      showHomeLink: {
        type: Boolean,
        default: false
      }
    }
);

console.log(props);

const store = useStore();
const router = useRouter();

const statusText = computed(() => store.getters.responseError);


const logout = async () => {
  await store.dispatch("logout");
}

const admin = () => {
  router.push({name: "Admin"});
}


const openContactForm = () => {
  const contactForm = document.getElementById('contactForm');
  const contactFormModal = Modal.getOrCreateInstance(contactForm);
  contactFormModal.show();
};

const currentRouteName = computed(() => router.currentRoute.value.name);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isAdmin = computed(() => store.getters.isAdmin);

console.log(router.currentRoute.value);

const showTopbar = computed(() => router.currentRoute.value.meta?.public !== true );

onMounted(() => {
  store.dispatch("resetResponseError");
})

</script>

<style scoped>

</style>